module.exports = __webpack_public_path__ + "public/adminIcons/changePwd.svg?1d5be689";